import { render } from "./FormRegisterUserComponent.vue?vue&type=template&id=77da91c6&scoped=true"
import script from "./FormRegisterUserComponent.vue?vue&type=script&lang=js"
export * from "./FormRegisterUserComponent.vue?vue&type=script&lang=js"

import "./FormRegisterUserComponent.vue?vue&type=style&index=0&id=77da91c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77da91c6"]])

export default __exports__